// src/components/goals/GoalsMobileView.tsx
import React from 'react';
import { Edit, Trash2, Search, RefreshCw } from 'lucide-react';
import { GoalData } from '../../pages/Goals'; // Adjust path
import Pagination from '../shared/Pagination'; // Adjust path

interface GoalsMobileViewProps {
  paginatedData: GoalData[];
  apiLoading: boolean;
  searchTerm: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleEdit: (goal: GoalData) => void;
  handleDelete: (id: string) => void;
  getLabel: (group: string, value: string) => string;
  formatCurrency: (value: string | number) => string;
  paginationProps: any;
}

const GoalCard: React.FC<Omit<GoalsMobileViewProps, 'paginatedData' | 'apiLoading' | 'searchTerm' | 'onSearchChange' | 'paginationProps'> & { goal: GoalData }> = ({
    goal, handleEdit, handleDelete, getLabel, formatCurrency
}) => (
    <div className="bg-white rounded-lg p-3 shadow border border-gray-200 flex flex-col">
        <div className="flex justify-between items-start mb-2">
            <div className="text-purple-800 font-bold truncate text-sm">
                {getLabel('goalType', goal.goalType) || 'Goal'}
            </div>
            <div className="flex space-x-1">
                <button onClick={() => handleEdit(goal)} className="p-1 text-purple-600"><Edit className="w-4 h-4" /></button>
                <button onClick={() => handleDelete(goal.id)} className="p-1 text-red-600"><Trash2 className="w-4 h-4" /></button>
            </div>
        </div>
        <div className="mb-2">
            <p className="text-base font-bold text-purple-600 text-center truncate">{formatCurrency(goal.goalTarget)}</p>
        </div>
        <div className="space-y-1 text-xs text-gray-600 text-center">
            <div className="text-gray-800 font-medium truncate">{goal.goalName}</div>
            {goal.goalSubType && <div className="text-gray-600 truncate">{getLabel('goalSubType', goal.goalSubType)}</div>}
            {goal.goalTargetTenure && <div className="text-gray-600">{goal.goalTargetTenure} years</div>}
        </div>
    </div>
);

const GoalsMobileView: React.FC<GoalsMobileViewProps> = ({ paginatedData, apiLoading, searchTerm, onSearchChange, paginationProps, ...rest }) => {
    return (
        <div className="md:hidden">
            <div className="p-2">
                <div className="relative max-w-md mx-auto mb-4">
                    <input type="text" placeholder="Search goals..." value={searchTerm} onChange={onSearchChange} className="w-full p-2 pl-10 border rounded-lg text-sm" />
                    <Search className="w-5 h-5 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                </div>
            </div>
            {apiLoading ? (
                <div className="text-center py-12"><RefreshCw className="w-6 h-6 animate-spin text-purple-600" /></div>
            ) : (
                <div className="grid grid-cols-2 gap-4 px-2">
                    {paginatedData.map(goal => <GoalCard key={goal.id} goal={goal} {...rest} />)}
                </div>
            )}
            {paginationProps.totalItems > paginationProps.itemsPerPage && !apiLoading && (
                <Pagination {...paginationProps} isMobile />
            )}
        </div>
    );
};

export default GoalsMobileView;